import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import './style.css';
import { Parallax } from 'react-scroll-parallax';
import imageNana from '../../../../assets/images/image-nana.jpg';
import imagePandora from '../../../../assets/images/image-pandora.jpg';
import imagePuyo from '../../../../assets/images/image-puyo.jpg';
import imageST from '../../../../assets/images/image-st.jpg';

export default class Featured extends Component {
  render() {
    return (
      <section>
        <section className="featured-title">
          <div className="featured-title-item-1 tc">
            <Fade>
            Featured Works
            </Fade>
          </div>
        </section>
        <section className="featured-container w-100 z-3">
            <div className="line-container"></div>
            <div className="title-child-1 flex flex-column content-center justify-center tc pointer">
              <div>
                <a className="year" href="https://pandoraexperience.com/" target="_blank" rel="noopener noreferrer"> Brand Design </a>
              </div>
              <div>
                <a className="work-title" href="https://pandoraexperience.com/" target="_blank" rel="noopener noreferrer"> Pandora Experience </a>
              </div>
              <div className="title-child-underline"></div>
            </div>
            <Parallax className="image-child-1 pointer" offsetYMax={20} offsetYMin={-20} slowerScrollRatetag="figure">
                  <img className="works-image" onClick={()=> window.open("https://pandoraexperience.com/", "_blank")}  data-src={imagePandora} src={imagePandora} alt="first featured work"></img>
            </Parallax>
            <div className="title-child-2  flex flex-column content-center justify-center tc pointer">
              <div>
                <a className="year" href="https://www.instagram.com/nanacakeboutique/" target="_blank" rel="noopener noreferrer"> Brand Design </a>
              </div>
              <div>
                <a className="work-title" href="https://www.instagram.com/nanacakeboutique/" target="_blank" rel="noopener noreferrer"> Nana Cake Boutique </a>
              </div>
              <div className="title-child-underline"></div>
            </div>
            <Parallax className="image-child-2 pointer" offsetYMax={20} offsetYMin={-20} slowerScrollRatetag="figure">
                  <img className="works-image" onClick={()=> window.open("https://www.instagram.com/nanacakeboutique/", "_blank")} data-src={imageNana} src={imageNana} alt="second featured work"></img>
            </Parallax>
            <div className="title-child-3  flex flex-column content-center justify-center tc pointer">
              <div>
                <a className="year" href="https://www.puyodesserts.com" target="_blank" rel="noopener noreferrer"> UI/UX Design </a>
              </div>
              <div >
                <a  className="work-title"href="https://www.puyodesserts.com" target="_blank" rel="noopener noreferrer"> Puyo Desserts </a>
              </div>
              <div className="title-child-underline"></div>
            </div>
            <Parallax className="image-child-3 pointer" offsetYMax={20} offsetYMin={-20} slowerScrollRatetag="figure">
                  <img className="works-image" onClick={()=> window.open("https://www.puyodesserts.com", "_blank")} data-src={imagePuyo} src={imagePuyo} alt="third featured work"></img>
            </Parallax>
            <div className="title-child-4 flex flex-column content-center justify-center tc pointer">
                <div>
                  <a className="year" href="https://www.styletheory.co" target="_blank" rel="noopener noreferrer"> Mobile Dev</a>
                </div>
                <div>
                  <a className="work-title" href="https://www.styletheory.co" target="_blank" rel="noopener noreferrer"> Style Theory</a>
                </div>
                <div className="title-child-underline"></div>
            </div>
            <Parallax className="image-child-4 pointer" offsetYMax={20} offsetYMin={-20} slowerScrollRatetag="figure">
                  <img className="works-image" onClick={()=> window.open("https://www.styletheory.co", "_blank")} data-src={imageST} src={imageST} alt="fourth featured work"></img>
            </Parallax>
            <div className="title-child-5 flex flex-column content-center justify-center tc">
              <div className="year year-end"> etc.
              </div>
              <div className="work-title title-end"> And Many More...
              </div>
            </div>
        </section>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Sections/Featured/index.jsx